export default __webpack_public_path__ + "static/media/poutre.a27c3443.png";